Object.defineProperty(exports,"__esModule",{value:true});exports.default=


setDefaultThemeStyle;var _nativeBaseShoutemTheme=require("native-base-shoutem-theme");var _components=require("./theme/components");var _components2=_interopRequireDefault(_components);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function setDefaultThemeStyle(){
var theme=(0,_components2.default)();
_nativeBaseShoutemTheme.Theme.setDefaultThemeStyle(theme);
}
//# sourceMappingURL=init.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/native-base/dist/src/init.js
// module id = 408
// module chunks = 0